<template>
  <div class="h-full">
    <div class="h-20px d-flex align-center justify-center">
      <v-row class="ma-0 pa-0 justify-center">
        <div class="d-flex align-center px-2">
          <div class="quadrado-12 b-radius-50-percento" style="background: #000000" />
          <span class="pl-1 font-12">Demanda Histórica</span>
        </div>

        <div
          v-for="(tipo_projecao_venda, key) in tipos_projecao_vendas_selecionados"
          :key="key"
          class="d-flex align-center px-2"
        >
          <div class="quadrado-12 b-radius-50-percento" :style="{background: cores[tipo_projecao_venda.index]}" />
          <div class="pl-1 font-12 text-truncate">{{ tipo_projecao_venda.descricao }}</div>
        </div>
      </v-row>
    </div>

    <div :id="ID_COMPONENTE_COMPUTED" style="width: 100%;height: calc(100% - 20px);" />
  </div>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import * as echarts from 'echarts';
import {formatarValorComCasas, logout} from "@/helpers";
import {
  descricao_index_tipo_projecao_vendas,
  index_tipos_projecao_vendas
} from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";
import {cores} from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";
import api from "@/api/api";

const props = defineProps({
  produto: Object,
  tipos_projecao_vendas_selecionados: Array,
});

const ID_COMPONENTE_COMPUTED = computed(() => {
  return `${props.produto.id_grupo}-${props.produto.id_filial}-${props.produto.id_produto}-${props.produto.produto_eh_combinacao}`;
});

const OPCOES_GRAFICO_COMPUTED = computed(() => ({
  grid: {
    left: '0',
    right: '10px',
    bottom: '0%',
    containLabel: true,
    shadowOffsetX: {
      show: true,
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        formatter: label => {
          if (label.axisDimension === 'y') {
            return formatarValorComCasas(Number(label.value), 2);
          }
          return label.value;
        }
      }
    },
    valueFormatter: valor => formatarValorComCasas(valor, 2)
  },
  legend: {
    show: false,
  },
  toolbox: {
    show: false,
    feature: {
      saveAsImage: {}
    }
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: dados_historico_para_grafico.value.referencias,
  },
  yAxis: {
    type: 'value'
  },
  series: SERIES_COMPUTED.value,
}));

const SERIES_COMPUTED = computed(() => {
  const serie_demanda_historica = {
    name: 'Demanda Histórica',
    type: 'line',
    smooth: 0.3,
    symbol: 'none',
    lineStyle: {
      color: '#000000',
      width: 5
    },
    data: dados_historico_para_grafico.value.demanda_historica
  };

  const series_tipos_projecoes = props.tipos_projecao_vendas_selecionados.map(tipo => {
    return {
      index_tipo_projecao_vendas: index_tipos_projecao_vendas.mediana,
      name: descricao_index_tipo_projecao_vendas[tipo.index],
      type: 'line',
      smooth: 0.3,
      symbol: 'none',
      color: cores[tipo.index],
      lineStyle: {
        color: cores[tipo.index],
        width: 2
      },
      data: dados_historico_para_grafico.value[tipo.index]
    };
  });

  return [serie_demanda_historica, ...series_tipos_projecoes];
});

let grafico;

onMounted(async () => {
  const chartDom = document.getElementById(ID_COMPONENTE_COMPUTED.value);

  grafico = echarts.init(chartDom);
  grafico.setOption(OPCOES_GRAFICO_COMPUTED.value);

  await nextTick();
  grafico.resize();

  window.addEventListener('resize', () => grafico.resize());

  buscarDadosGrafico();
});

watch(() => props.tipos_projecao_vendas_selecionados, () => {
  grafico.setOption(OPCOES_GRAFICO_COMPUTED.value, true);
});

const dados_historico_para_grafico = ref({});

function buscarDadosGrafico() {
  const params = {
    ...props.produto,
    produto_eh_combinacao: props.produto.produto_eh_combinacao ? 'S' : 'N',
  };

  api.get('produtos/projecao-vendas/parametrizacao/tipos-projecoes/grafico', { params })
    .then(resposta => {
      dados_historico_para_grafico.value = resposta.data.historico;
      grafico.setOption(OPCOES_GRAFICO_COMPUTED.value, true);
    })
    .catch(logout)
}
</script>
